import React from 'react';
import { __ } from '../../Lang.js';
import PersonalUseBadge from './PersonalUseBadge.jsx';

const VideoBadges = ({ video }) => {
    const isAudio = video.asset_type?.toLowerCase() === 'audio';
    const isVideo = video.asset_type?.toLowerCase() === 'video';
    const isPersonal = video.usage_type?.toLowerCase() === 'personal' || video.usage_type?.toLowerCase() === 'personal use';
    const isMinister = video.usage_type?.toLowerCase() === 'minister' || video.usage_type?.toLowerCase() === 'minster or initiate' || video.usage_type?.toLowerCase() === 'minister or initiate';
    const isInitiate = video.usage_type?.toLowerCase() === 'initiate' || video.usage_type?.toLowerCase() === 'minster or initiate' || video.usage_type?.toLowerCase() === 'minister or initiate';
    const isSatSubscriber = video.usage_type?.toLowerCase() === 'sat';
    const isDiscourse = video.usage_type?.toLowerCase() === 'discourse';
    const isPremium = video.visibility === 'SVOD Only';

    return (
        <div className="video-card__badges">
            {isAudio && (
                <span className="video-card__badge">
                    {__('Audio')}
                </span>
            )}
            {isVideo && (
                <span className="video-card__badge">
                    {__('Video')}
                </span>
            )}
            {isPersonal && <PersonalUseBadge />}
            {isMinister && (
                <span className="video-card__badge video-card__badge--minister">
                    {__('Minister')}
                </span>
            )}
            {isInitiate && (
                <span className="video-card__badge video-card__badge--initiate">
                    {__('Initiate')}
                </span>
            )}
            {isSatSubscriber && (
                <span className="video-card__badge video-card__badge--sat">
                    {__('SAT')}
                </span>
            )}
            {isDiscourse && (
                <span className="video-card__badge video-card__badge--discourse">
                    {__('Discourse')}
                </span>
            )}
            {isPremium && (
                <span className="video-card__badge video-card__badge--premium" style={{ marginLeft: 'auto' }}>
                    {__('Premium')}
                </span>
            )}
        </div>
    );
};

export default VideoBadges;
